<template>
  <div class="jumbotron">
    <h1 class="display-4">404 - Pas trouvé</h1>
    <p class="lead">Cette page n'existe pas!</p>
    <hr class="my-4">
    <p>Rentrez en contact avec l'administrateur du système au cas d'un malfonctionement du système.</p>
    <p class="lead">
      <a class="btn btn-primary btn-lg" href="/" role="button">Retourner à page principale</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue